import { FormattedMessage, useIntl } from "react-intl";
import { Heading, StatCard } from "@lendcord/concord";
import { useGetPortfolioSummaryQuery } from "@/features/dashboard/api/dashboard.api";

const currencyFormatter = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  maximumFractionDigits: 0,
});

function format(value: number | undefined): string {
  return value === undefined ? "–" : currencyFormatter.format(value);
}

export function PortfolioSection() {
  const intl = useIntl();
  const { data: portfolio } = useGetPortfolioSummaryQuery();

  return (
    <section>
      <Heading level={2} className="mb-4">
        <FormattedMessage id="lender.portfolioSection.heading" />
      </Heading>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        <StatCard
          label={intl.formatMessage({ id: "lender.portfolioSection.totalFundsAddedLabel" })}
          value={format(portfolio?.totalFundsAdded)}
          loading={!portfolio}
          hint={
            portfolio
              ? intl.formatMessage(
                  { id: "lender.portfolioSection.withdrawnLabel" },
                  { amount: format(portfolio.withdrawn) }
                )
              : undefined
          }
        />
        <StatCard
          label={intl.formatMessage({ id: "lender.portfolioSection.interestEarnedLabel" })}
          value={format(portfolio?.interestEarned)}
          loading={!portfolio}
        />
        <StatCard
          label={intl.formatMessage({ id: "lender.portfolioSection.netAssetValueLabel" })}
          value={format(portfolio?.netAssetValue)}
          loading={!portfolio}
        />
      </div>
    </section>
  );
}
